import { useQuery } from "@tanstack/react-query";
import {
  getUnmappedSessions,
  UnmappedSessionParams,
} from "../services/get-unmapped-sessions";

export function useUnmappedSessions(params: UnmappedSessionParams) {
  return useQuery({
    queryKey: ["unmapped-sessions", params],
    queryFn: () => getUnmappedSessions(params),
    staleTime: 1000 * 60 * 2,
  });
}
